import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  mode: 'hash',
  scrollBehavior () {
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: '/index',
      name: 'index',
      alias: '/',
      component: () => import('@/views/index/index.vue')
    },
    {
      path: '/videoMore',
      name: 'videoMore',
      component: () => import('@/views/videoMore')
    },
    {
      path: '/primaryBusiness',
      name: 'PrimaryBusiness',
      component: () => import('@/views/primaryBusiness/index.vue'),
      children: [
        {
          path: 'cloudChainNo1',
          name: 'CloudChainNo1',
          component: () => import('@/views/primaryBusiness/cloudChainNo1/index.vue'),
          children: [
            {
              path: 'computerProtal',
              name: 'ComputerProtal',
              component: () => import('@/views/primaryBusiness/cloudChainNo1/computerProtal/index.vue')
            },
            {
              path: 'computerService',
              name: 'ComputerService',
              component: () => import('@/views/primaryBusiness/cloudChainNo1/computerService/index.vue')
            },
            {
              path: 'intelligent',
              name: 'Intelligent',
              component: () => import('@/views/primaryBusiness/cloudChainNo1/intelligent/index.vue')
            }
          ]
        },
        {
          path: 'softwareProduct',
          name: 'SoftwareProduct',
          component: () => import('@/views/primaryBusiness/softwareProduct/index.vue'),
          children: [
            {
              path: 'easyCall',
              name: 'EasyCall',
              component: () => import('@/views/primaryBusiness/softwareProduct/easyCall/index.vue')
            },
            {
              path: 'crm',
              name: 'CRM',
              component: () => import('@/views/primaryBusiness/softwareProduct/crm/index.vue')
            }
          ]
        },
        {
          path: 'computerService',
          name: 'ComputerService',
          component: () => import('@/views/primaryBusiness/computerService/index.vue'),
          children: [
            {
              path: 'idc',
              name: 'IDC',
              component: () => import('@/views/primaryBusiness/computerService/idc/index.vue')
            },
            {
              path: 'computerServer',
              name: 'ComputerServer',
              component: () => import('@/views/primaryBusiness/computerService/computerServer/index.vue')
            }
          ]
        },
        {
          path: 'serviceCentre',
          name: 'ServiceCentre',
          component: () => import('@/views/primaryBusiness/serviceCentre/index.vue'),
          children: [
            {
              path: 'question',
              name: 'Question',
              component: () => import('@/views/primaryBusiness/serviceCentre/question/index.vue')
            }
          ]
        }
      ]
    },
    // 关于我们
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import('@/views/aboutUs/index')
    },
    // 联系我们
    {
      path: '/contactUs',
      name: 'contactUs',
      component: () => import('@/views/contactUs/index')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js